import './index.scss';

export class QuantitySelect extends HTMLElement {
  static get observedAttributes() {
    return ['disabled'];
  }

  constructor() {
    super();
    this.model = {
      value: 1,
    };
    this.onValueChange = null;
    this.initRender();
    this.onInputBind = this.onInput.bind(this);
    this.onBlurBind = this.onBlur.bind(this);
    this.onButtonActionBind = this.onButtonAction.bind(this);
  }
  get value() {
    return this.model.value;
  }
  get disabled() {
    return this.hasAttribute('disabled');
  }
  connectedCallback() {
    this.bindEvents();
  }
  disconnectedCallback() {
    this.removeEventsListener();
  }
  attributeChangedCallback(name) {
    if (name === 'disabled') {
      this.renderStatus();
    }
  }
  setValue(newValue) {
    if (newValue === this.model.value) {
      return;
    }
    this.model.value = newValue;
    this.render();
    if (this.onValueChange) {
      this.onValueChange(newValue);
    }
  }
  initRender() {
    this.innerHTML = `
      <button class="quantity-select__action js-minus"><i class="fa fa-minus"></i></button>
      <input value="${this.model.value}">
      <button class="quantity-select__action js-plus"><i class="fa fa-plus"></i></button>
    `;
  }
  render() {
    const $input = this.querySelector('input');
    const { value } = this.model;
    $input.value = value;
    this.renderStatus();
  }
  renderStatus() {
    const $input = this.querySelector('input');
    if (this.disabled) {
      $input.setAttribute('disabled', 'disabled');
    } else {
      $input.removeAttribute('disabled');
    }
  }
  bindEvents() {
    // Input onblur & oninput event cannot bubble, event delegation is not used
    this.querySelector('input').addEventListener('input', this.onInputBind);
    this.querySelector('input').addEventListener('blur', this.onBlurBind);
    this.addEventListener('click', this.onButtonActionBind);
  }
  removeEventsListener() {
    this.querySelector('input').removeEventListener('input', this.onInputBind);
    this.querySelector('input').removeEventListener('blur', this.onBlurBind);
    this.removeEventListener('click', this.onButtonActionBind);
  }
  onInput(e) {
    const newValue = Number(e.target.value);

    if (e.target.value.length === 0) {
      return;
    }
    if (!/^\d*$/.test(e.target.value)) {
      e.target.value = this.model.value;
      return;
    }
    this.setValue(newValue);
  }
  onBlur(e) {
    if (e.target.value.length === 0) {
      e.target.value = this.model.value;
    }
  }
  onButtonAction(e) {
    if (this.disabled) {
      return;
    }

    const $button = e.target.closest('button');

    if (!$button) {
      return;
    }

    if ($button.classList.contains('js-minus')) {
      this.onMinus();
    } else if ($button.classList.contains('js-plus')) {
      this.onPlus();
    }
  }
  onMinus() {
    if (this.model.value === 1) {
      return;
    }
    this.setValue(this.model.value - 1);
  }
  onPlus() {
    this.setValue(this.model.value + 1);
  }
}

if (!customElements.get('quantity-select')) {
  customElements.define('quantity-select', QuantitySelect);
}
